<script setup lang="ts">
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/core/components/ui/dropdown-menu";
import {EllipsisVertical, FlaskConical, FlaskConicalOff} from "@lucide/vue";
import {ref} from "vue";

const emit = defineEmits(['toggle-advanced']);
const advanced = ref(false);

/**
 * Toggle the advanced options visibility and emit an event.
 */
const toggleAdvanced = () => {
    advanced.value = !advanced.value;
    emit('toggle-advanced', advanced.value);
};
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <EllipsisVertical :size="20" class="text-gray" />
    </DropdownMenuTrigger>
    <DropdownMenuContent side="left">
      <DropdownMenuItem v-if="advanced" class="flex items-center" @click="toggleAdvanced">
        <FlaskConicalOff />
        Masquer les options avancées
      </DropdownMenuItem>
      <DropdownMenuItem v-if="!advanced" class="flex items-center" @click="toggleAdvanced">
        <FlaskConical />
        Afficher les options avancée
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
